import { UserFindDto, type UserFindInterface } from '@zaoblako/shared/modules/security/dtos/user/user-find.dto';
import { EavAttributeFindDto, type EavAttributeFindInterface } from '@zaoblako/shared/modules/eav/dtos/attribute/eav-attribute-find.dto';
import { EavComputedAttributeTokenDto, type EavComputedAttributeTokenInterface } from '@zaoblako/shared/modules/eav/dtos/eav-computed-attribute-token.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { EavDtoKeysEnum } from '@zaoblako/shared/modules/eav/enums/eav-dto-keys.enum';

import * as yup from 'yup';

/** EAV entity response body - DTO signature */
export interface EavEntityFindInterface {
  /** Unique ID */
  id: number;
  /** Creation date and time */
  created: Date;
  /** Last update date and time */
  updated: Date;
  /** Soft deletion update date and time. The EAV entity instance will be permanently deleted six months after this date. */
  deleted?: Date;
  /** User who created this EAV entity instance */
  createdBy?: UserFindInterface;
  /** Entity values: dictionary where key is attribute unique ID and value is concrete value */
  values: Record<number, any>;
  /** Attributes using by this entity */
  attributes?: EavAttributeFindInterface[];
  /** Tokens for computed attributes */
  tokens?: EavComputedAttributeTokenInterface[];
}

/** EAV entity response body - DTO schema */
export const EavEntityFindDto = SerdeDtoClass.create<EavEntityFindInterface>(EavDtoKeysEnum.EAV_ENTITY_FIND_DTO, {
  id: {
    sortable: true,
    label: 'Номер',
    serializer: yup.number(),
  },
  created: {
    sortable: true,
    label: 'Создан',
    serializer: yup.date(),
  },
  updated: {
    sortable: true,
    label: 'Изменен',
    serializer: yup.date(),
  },
  deleted: {
    optional: true,
    label: 'Удален',
    serializer: yup.date(),
  },
  createdBy: {
    optional: true,
    label: 'Автор',
    nested: UserFindDto,
    serializer: (_, nested) => nested,
  },
  values: {
    label: 'Значения полей',
    serializer: yup.mixed(),
  },
  attributes: {
    optional: true,
    label: 'Поля',
    nested: EavAttributeFindDto,
    serializer: (_, nested) => yup.array(nested),
  },
  tokens: {
    optional: true,
    label: 'Токены для подстановки в вычисляемые поля',
    nested: EavComputedAttributeTokenDto,
    serializer: (_, nested) => yup.array(nested),
  },
});
